"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _reactQuery = require("react-query");
var _lcHttp = _interopRequireDefault(require("lc-http"));
var flattenOfferItems = function flattenOfferItems(offers) {
  return offers.map(function (_ref) {
    var offerItems = _ref.offerItems;
    return offerItems;
  }).reduce(function (acc, curr) {
    return [].concat((0, _toConsumableArray2.default)(acc), (0, _toConsumableArray2.default)(curr));
  }, []);
};
var fetchOffers = function fetchOffers(offerURL, _ref2) {
  var oracleApplicationId = _ref2.oracleApplicationId,
    amount = _ref2.amount,
    secondaryPayeeClientId = _ref2.secondaryPayeeClientId;
  return _lcHttp.default.get("\n      ".concat(offerURL, "?oracleApplicationId=").concat(oracleApplicationId, "&amount=").concat(amount, "&secondaryPayeeClientId=").concat(secondaryPayeeClientId)).then(function (res) {
    return flattenOfferItems(res.data);
  });
};
var useOffers = function useOffers(offerURL, _ref3) {
  var oracleApplicationId = _ref3.oracleApplicationId,
    amount = _ref3.amount,
    secondaryPayeeClientId = _ref3.secondaryPayeeClientId;
  return (0, _reactQuery.useQuery)(['offers', {
    oracleApplicationId: oracleApplicationId,
    amount: amount
  }], function () {
    return fetchOffers(offerURL, {
      oracleApplicationId: oracleApplicationId,
      amount: amount,
      secondaryPayeeClientId: secondaryPayeeClientId
    });
  }, {
    keepPreviousData: true
  });
};
var _default = useOffers;
exports.default = _default;
